import { HttpClient } from "@angular/common/http";
import { Inject, Injectable, inject } from "@angular/core";
import { EnvConfig, Environment } from "@doc/core";
import { of } from "rxjs";

import { ApiUrls } from "../backoffice-urls";

@Injectable({
  providedIn: "root",
})
export class DepartmentService {
  private http = inject(HttpClient);
  private apiUrl: string;
  private baseUrl: string;

  constructor(@Inject(EnvConfig) private config: Environment) {
    this.baseUrl = this.config.mockUrl;
    this.apiUrl = this.config.apiUrl;
  }

  getDepartmentList(body: any) {
    const link = this.apiUrl + ApiUrls.getDepartmentList;
    return this.http.post<any>(link, body);
  }
  getWorkflowBydepartment(body: any) {
    const link = this.apiUrl + ApiUrls.getWorkflowByDepartment;
    return this.http.get<any>(link + "/" + body);
  }
  getUserbyDepartment(body: any) {
    const link = this.apiUrl + ApiUrls.getusersbydept;
    return this.http.post<any>(link, body);
  }

  getUserByRoleAndDepartment(body: any) {
    const link = this.apiUrl + ApiUrls.getUserByRoleAndDepartment;
    return this.http.post<any>(link, body);
  }

  getDepartmentByLoggedInUser() {
    const link = this.apiUrl + ApiUrls.getDepartmentByLoggedInUser;
    return this.http.get<any>(link);
  }

  createDepartment(body: any) {
    const link = this.apiUrl + ApiUrls.createDepartment;
    return this.http.post<any>(link, body);
  }

  getDepartmentById(id: number) {
    const link = this.apiUrl + ApiUrls.getDepartmentById + "/" + id;
    return this.http.get<any>(link);
  }
  updateDepartment(body: any) {
    const link = this.apiUrl + ApiUrls.updateDepartment;
    return this.http.post<any>(link, body);
  }

  deleteDepartment(id: number) {
    const link = `${this.apiUrl}${ApiUrls.deleteDepartment}/${id}`;
    return this.http.post<any>(link, { id });
  }
}
